export const CLOSE_DIALOG_GROUP = 'lumahealth/DialogGroup/CLOSE_DIALOG_GROUP';

export const DELETE_GROUP = 'lumahealth/DialogGroup/DELETE_GROUP';
export const DELETE_GROUP_SUCCESS = 'lumahealth/DialogGroup/DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_ERROR = 'lumahealth/DialogGroup/DELETE_GROUP_ERROR';

export const DIALOG_GROUP_FORM = 'DialogGroupForm';

export const LOAD_FACILITIES = 'lumahealth/DialogGroup/LOAD_FACILITIES';
export const LOAD_FACILITIES_SUCCESS = 'lumahealth/DialogGroup/LOAD_FACILITIES_SUCCESS';
export const LOAD_FACILITIES_ERROR = 'lumahealth/DialogGroup/LOAD_FACILITIES_ERROR';

export const LOAD_USERS = 'lumahealth/DialogGroup/LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'lumahealth/DialogGroup/LOAD_USERS_SUCCESS';
export const LOAD_USERS_ERROR = 'lumahealth/DialogGroup/LOAD_USERS_ERROR';

export const OPEN_DIALOG_GROUP = 'lumahealth/DialogGroup/OPEN_DIALOG_GROUP';

export const SAVE_GROUP = 'lumahealth/DialogGroup/SAVE_GROUP';
export const SAVE_GROUP_SUCCESS = 'lumahealth/DialogGroup/SAVE_GROUP_SUCCESS';
export const SAVE_GROUP_ERROR = 'lumahealth/DialogGroup/SAVE_GROUP_ERROR';

export const LOAD_GROUPS = 'lumahealth/DialogGroup/LOAD_GROUPS';
